<template>
  <div>
    <v-divider></v-divider>
    <v-card-actions class @click.stop="show = !show">
      <h3>{{ title }}</h3>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="show = !show">
        <v-icon v-if="show">fa-minus</v-icon>
        <v-icon v-else>fa-chevron-down</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <div class>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <template v-for="(column, c) in columns">
                    <th class="text-left" v-if="column" :key="c">
                      {{ column }}
                    </th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in items" :key="`row-${i}`">
                  <td v-if="item.column_1">
                    <a
                      target="_blank"
                      :href="item.column_1"
                      v-if="item.column_1.startsWith('http')"
                      >Visit site</a
                    >
                    <span v-else>{{ item.column_1 }}</span>
                  </td>
                  <td v-if="item.column_2">
                    <a
                      target="_blank"
                      :href="item.column_2"
                      v-if="item.column_2.startsWith('http')"
                      >Visit site</a
                    >
                    <span v-else>{{ item.column_2 }}</span>
                  </td>
                  <td v-if="item.column_3">
                    <a
                      target="_blank"
                      :href="item.column_3"
                      v-if="item.column_3.startsWith('http')"
                      >Visit site</a
                    >
                    <span v-else-if="item.column_3.startsWith('fa-')">{{
                      item.column_3
                    }}</span>
                    <span v-else>{{ item.column_3 }}</span>
                  </td>
                  <td v-if="item.column_4">
                    <a
                      target="_blank"
                      :href="item.column_4"
                      v-if="item.column_4.startsWith('http')"
                      >Visit site</a
                    >
                    <span v-else>{{ item.column_4 }}</span>
                  </td>
                  <td v-if="item.column_5">
                    <a
                      target="_blank"
                      :href="item.column_5"
                      v-if="item.column_5.startsWith('http')"
                      >Visit site</a
                    >
                    <span v-else-if="item.column_5.startsWith('fa-')">
                      <v-icon small>{{ item.column_5 }}</v-icon>
                    </span>
                    <span v-else>{{ item.column_5 }}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "ProjectSection",
  props: ["title", "columns", "items"],
  data() {
    return {
      show: true,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
</style>